interface AEOBlockProps {
  question: string;
  answer: string;
}

const AEOBlock = ({ question, answer }: AEOBlockProps) => {
  return (
    <div className="aeo-block">
      <h2 className="text-lg font-semibold text-foreground mb-3">{question}</h2>
      <p className="text-muted-foreground leading-relaxed">{answer}</p>
    </div>
  );
};

export default AEOBlock;
